/*
 * Persist platform choice in a cookie
 *
 * Due to this site being behind a CDN, we set the platform choice in a cookie
 * using JS. If the user does not have a platform cookie, or if the user's
 * platform cookie differs from the platform currently selected, the cookie is
 * set.
 */

(() => {
  const PLATFORM_COOKIE = "platform_choice";
  const LIFETIME_DAYS = 10;

  function persistPlatform(platform) {
    const platformCookieValue = Cookies.get("platform_choice");

    if (platformCookieValue != platform) {
      Cookies.set(PLATFORM_COOKIE, platform, { expires: LIFETIME_DAYS });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const pathComponents = window.location.pathname.split("/");

    if (pathComponents.indexOf("windows") > -1) {
      persistPlatform("windows");
    }
    else if (pathComponents.indexOf("mac") > -1) {
      persistPlatform("mac");
    }
  });
})();
